import { api } from "@/builders/axios";

export function activate_deactivate(data: {
  id: number;
  data: { is_active: boolean };
}) {
  return api.post(`staffs/${data.id}/activate-or-deactivate`, data);
}
